import { Injectable } from '@angular/core';
import {CanActivate, Router} from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate() {

    if (localStorage.getItem('currentUser')) {
      // logged in so return true
      return true;
    }

    // not logged in so redirect to login page
    const returnToUrl = this.removeURLParameter(window.location.href, 'returnTo');
    const relativeUrl = returnToUrl.replace(/^(?:\/\/|[^/]+)*\//, '');
    const params = {};

    if(relativeUrl) {
      params['queryParams'] = {returnTo: relativeUrl};
    }

    this.router.navigate(['/login'], params);
    return false;
  }

  removeURLParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts= url.split('?');
    if (urlparts.length>=2) {

      var prefix= encodeURIComponent(parameter)+'=';
      var pars= urlparts[1].split(/[&;]/g);

      //reverse iteration as may be destructive
      for (var i= pars.length; i-- > 0;) {
        //idiom for string.startsWith
        if (pars[i].lastIndexOf(prefix, 0) !== -1) {
          pars.splice(i, 1);
        }
      }

      url= urlparts[0]+ ( pars.length > 0 ? ('?'+pars.join('&')) : '');
      return url;
    } else {
      return url;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/auth.guard.ts